<template>
  <div class="areaSelect" style="display: flex">
    <p style="padding-right: 4px;height: 36px;line-height: 36px;">
      <span v-for="(item, index) in names" :key="index">
        {{ item.name }}/
      </span>
    </p>
    <a-cascader
      style="flex:1;line-height: 100%;margin-top: 3px"
      v-if="options.length > 0"
      :value="value"
      :options="options"
      @change="onChange"
      :loadData="loadData"
      placeholder="请选择区域"
      :showSearch="true"
      changeOnSelect
    />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    pid: {
      type: Number,
      required: false,
      default: -1
    },
    defaultValue: {
      type: Number,
      required: false,
      default: -1
    }
  },
  data() {
    return {
      value: [],
      names: [],
      options: []
    };
  },
  computed: {
    ...mapState({
      user: state => state.account.user
    })
  },
  methods: {
    getValue() {
      let v = this.value;
      if (!v || v == "") {
        let names = this.names;
        return names[names.length - 1].id;
      }
      v = v + "";
      let vs = v.split(",");
      return vs.length > 1 ? vs[vs.length - 1] : vs[0];
    },
    getValues() {
      let v = this.value;
      if (!v || v == "") {
        let names = this.names;
        return names.map(o => o.id + "");
      }
      return v;
    },
    onChange(value) {
      this.value = value;
      this.$emit("change", value);
    },
    reload() {
      let pid = this.pid;
      if (pid == -1) {
        pid = this.user.streetId;
      }
      this.$get("/area/select", { pid: pid, value: this.defaultValue }).then(
        r => {
          this.options = r.data.data.areas;
          this.names = r.data.data.names;
          this.$emit("loaded");
        }
      );
    },
    setValue(value) {
      let pid = this.pid;
      if (pid == -1) {
        pid = this.user.streetId;
      }
      this.$get("/area/default", { pid: pid, value: value }).then(r => {
        this.value = r.data.data.defaultValues;
        this.$emit("loaded");
      });
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
    }
  },
  mounted() {
    this.reload();
  }
};
</script>
<style>
.areaSelect .ant-cascader-picker {
  height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/select/AreaCascader.vue